module.exports = __webpack_public_path__ + "static/ithor-microwave-8a43c391b7571fc7f2b86fa2e72c20fd.gif";